// extracted by mini-css-extract-plugin
module.exports = {"with-navbar":"PrivateRoute_with-navbar__3uj83","with-subnavbar":"PrivateRoute_with-subnavbar__4UYu7"};